module.exports = __webpack_public_path__ + "static/media/DM130_better.e130af18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/DM130_better.jpg
// module id = 211
// module chunks = 0